﻿window.printPage = function printPage() {
  window.print();
};
